// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__2U7dJ","section":"home_section__JfEzi","p":"home_p__1xeuX","title":"home_title__1YGs_","video":"home_video__XrA5h"};